
const defaultState = Object.freeze({
        utxos: [],
        keys: [],
        externalKey: {},
        outputs: [],
        preparedOutput: {
            address: "",
            amount: 0,
        },
        serialized: "",
    });

export default function transactionReducer(state = defaultState, action = {type:'NO-OP'}) {
    switch( action.type ) {
        case 'TXNS-INIT':
            return initialize(state, action);
        case 'TXNS-TOGGLE-INPUT':
            return toggleInput(state, action);
        case 'TXNS-TOGGLE-KEY':
            return toggleKey(state, action);
        case 'TXNS-PREPARE-OUTPUT':
            return updatePreparedOutput(state, action);
        case 'TXNS-ADD-OUTPUT':
            return addOutput(state, action);
        case 'TXNS-REMOVE-OUTPUT':
            return removeOutput(state, action);
        default:
            return state;
    }
}


function initialize(state, action) {
    if( !action || !action.data ) {
        return state;
    }

    return {
        ...state,
        ...action.data,
    };
}


function toggleInput(state, action) {
    if( !action || !action.utxoId ) {
        return state;
    }

    const found = state.utxos.findIndex(x => x.id === action.utxoId),
        toggled = found !== -1 ? {
            ...state.utxos[found],
            selected: !state.utxos[found].selected,
        } : null;

    if( !toggled ) {
        return state;
    }

    return {
        ...state,
        utxos: [
            ...state.utxos.slice(0, found),
            toggled,
            ...state.utxos.slice(found + 1),
        ],
    };
}


function toggleKey(state, action) {
    if( !action || !action.keyName ) {
        return state;
    }

    const found = state.keys.findIndex(x => x.name === action.keyName),
        toggled = found !== -1 ? {
            ...state.keys[found],
            selected: !state.keys[found].selected,
        } : null;

    if( !toggled ) {
        return state;
    }

    return {
        ...state,
        keys: [
            ...state.keys.slice(0, found),
            toggled,
            ...state.keys.slice(found + 1),
        ],
    };
}


function updatePreparedOutput(state, action) {
    if( !action || (!action.hasOwnProperty('address') && !action.hasOwnProperty('amount')) ) {
        return state;
    }

    const prepared = {
            ...state.preparedOutput,
            address: action.hasOwnProperty('address') ? action.address : state.preparedOutput.address,
            amount: action.hasOwnProperty('amount') ? parseInt(action.amount, 10) : state.preparedOutput.amount,
        };

    return {
        ...state,
        preparedOutput: prepared,
    };
}


function addOutput(state, action) {
    if( state.preparedOutput.address === "" || state.preparedOutput.amount === 0 ) {
        return state;
    }

    return {
        ...state,
        outputs: [
            ...state.outputs,
            {
                ...state.preparedOutput,
            },
        ],
        preparedOutput: {
            address: "",
            amount: 0,
        },
    };
}


function removeOutput(state, action) {
    if( !action || typeof action.index !== 'number' ) {
        return state;
    }

    return {
        ...state,
        outputs: [
            ...state.outputs.slice(0, action.index),
            ...state.outputs.slice(action.index + 1),
        ],
    };
}









// WEBPACK FOOTER //
// ./src/reducers/transactions-reducer.js